/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Entry_WeekInputs */

const en_us2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week`)
};

const pt_br2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana passada`)
};

const es_419_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana pasada`)
};

const pt_pt2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana passada`)
};

const fr_fr2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine dernière`)
};

const de_de2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche`)
};

const it_it2_progress_report_entry_week = /** @type {(inputs: Progress_Report_Entry_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana scorsa`)
};

/**
* | output |
* | --- |
* | "Last week" |
*
* @param {Progress_Report_Entry_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_entry_week = /** @type {((inputs?: Progress_Report_Entry_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Entry_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_entry_week(inputs)
	if (locale === "es-419") return es_419_progress_report_entry_week(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_entry_week(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_entry_week(inputs)
	if (locale === "de-DE") return de_de2_progress_report_entry_week(inputs)
	if (locale === "it-IT") return it_it2_progress_report_entry_week(inputs)
	return en_us2_progress_report_entry_week(inputs)
});
export { progress_report_entry_week as "progress-report.entry_week" }